import React from 'react';
import TireSelectBottomSheetKR from '@di-shared/features/diag/tire/TireSelectBottomSheetKR';
import TireSelectBottomSheetEU from '@di-shared/features/diag/tireEU/TireSelectBottomSheetEU';
import TireSelectBottomSheetNa from '@di-shared/features/diag/tireNA/TireSelectBottomSheet.na';
import type {TireRecommendedResponse} from '@di-shared/features/diag/tireEU/types';
import Environment from '@di-shared/features/environment/Environment';

interface TireSelectionBottomSheetPageProps {
  vin: string;
}

/**
 * [2026-02-04:Jeyoung Lee] FIXME: 다음번 타이어KR 관련 QA를 탈 경우 EU방식으로 수정 필요함.
 * 타이어 선택 바텀시트 페이지
 *
 * - KR: useTirePressure 훅을 사용하여 API 호출 후 바텀시트 내에서 타이어 등록
 * - EU: window.data로 전달받은 tireRecommendedData를 사용하며, 선택된 타이어를 반환
 */
function TireSelectionBottomSheetPage({vin}: TireSelectionBottomSheetPageProps) {
  const tireRecommendedData = window?.data?.tireRecommendedData as unknown as TireRecommendedResponse;

  return (
    <>
      <Environment.Kr>
        <TireSelectBottomSheetKR vin={vin} />
      </Environment.Kr>
      <Environment.Eu>
        <TireSelectBottomSheetEU
          vin={vin}
          tireRecommendedData={tireRecommendedData}
        />
      </Environment.Eu>
      <Environment.Na>
        <TireSelectBottomSheetNa
          vin={vin}
          tireRecommendedData={tireRecommendedData}
        />
      </Environment.Na>
    </>
  );
}

export default TireSelectionBottomSheetPage;
